import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Frustrations } from '../components/Frustrations';
import { HowItWorks } from '../components/HowItWorks';
import { WhyUs } from '../components/WhyUs';
import { Testimonials } from '../components/Testimonials';
import { WaysWeHelp } from '../components/WaysWeHelp';
import { FaqPreview } from '../components/FaqPreview';
import { FinalCta } from '../components/FinalCta';
import { SiteFooter } from '../components/SiteFooter';
import { MobileBookingBar } from '../components/MobileBookingBar';
export function Home() {
  return <div className="w-full bg-paper font-sans" data-id="element-189" data-mp="2dhqk0x98yfiy">
      <a href="#main" className="sr-only z-[60] rounded-sm bg-gold px-4 py-2 font-semibold text-navy focus:not-sr-only focus:fixed focus:left-4 focus:top-4" data-id="element-190" data-mp="2dii1z59x8eqr">
        Skip to content
      </a>
      <SiteHeader data-id="element-191" data-mp="3ov2ewin13nsz" />
      <main id="main" data-id="element-192" data-mp="3oyq8tiwdyc88">
        <Hero data-id="element-193" data-mp="30wjbung70q3t" />
        <TrustBar data-id="element-194" data-mp="30x1j0f4e8oqi" />
        <Frustrations data-id="element-195" data-mp="30vgogpi2x5sn" />
        <HowItWorks data-id="element-196" data-mp="30up285adgkf1" />
        <WhyUs data-id="element-197" data-mp="2vxovds5p7dmv" />
        <Testimonials data-id="element-198" data-mp="2vx6qy88vtt3v" />
        <WaysWeHelp data-id="element-199" data-mp="2vyq8e269ya78" />
        <FaqPreview data-id="element-200" data-mp="2vy85wnt0qzqv" />
        <FinalCta data-id="element-201" data-mp="2vvvnyan9gpdt" />
      </main>
      <SiteFooter data-id="element-202" data-mp="2qy2glea81pby" />
      <MobileBookingBar data-id="element-203" data-mp="2qxkfo4cm6mxp" />
    </div>;
}